app.service('focusTrap',function() {
	function setFocusTrap($element) {
		// ustawienie focus trap na elemencie
		if ($element.hasClass('focustrapped')) {
			console.log('Element already has focus trap');
			return;
		}
		$element.addClass('focustrapped'); // ustawienie tabindex, aby element mógł być focusowany
		$element.before('<div class="focus-visually-hidden focus-trap-anchor-first" tabindex="0" aria-hidden="true"></div>'); // dodanie elementu focus trap
		$element.after('<div class="focus-visually-hidden focus-trap-anchor-last" tabindex="0" aria-hidden="true"></div>'); // dodanie elementu focus trap
	}
	function resetFocusTrap($target) {
		// resetowanie focus trap globalnie
		const $element = $target ? $target : $('body').find('.focustrapped');
		if (!$element.length) {
			return;
		}
		// usunięcie kotwic focus trap
		$element.prev('.focus-trap-anchor-first').remove();
		$element.next('.focus-trap-anchor-last').remove();
		$element.removeClass('focustrapped');
	}
	function findFocusableElements($parent) {
		// focus tylko na interaktywnych elementach, które nie są display:none
		return $parent.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:visible:not([tabindex="-1"])');
	}

	function init() {
		$('body').on('focusin', '.focus-trap-anchor-first', function(e) {
			// jeśli focus jest na pierwszym elemencie, to przenosimy focus na ostatni element
			findFocusableElements($(e.target).next()).eq(-1).focus();
		}).on('focusin', '.focus-trap-anchor-last', function(e) {
			// jeśli focus jest na ostatnim elemencie, to przenosimy focus na pierwszy element
			findFocusableElements($(e.target).prev()).eq(0).focus();
		});
	}

	return {
		init,
		set: setFocusTrap,
		reset: resetFocusTrap
	};
});
